export const MAX_DAPP_DESCRIPTION_LENGTH = 110;

export const MIN_IMG_FILE_SIZE = 5 * 1024 * 1024;
